import { useBreakpointValue } from '../../../theme';
// The default size for the table cell is 'm' according to DS
export var _useCellSize = function _useCellSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'm';

  var smallerScreenCellSize = () => {
    switch (size) {
      case 'm':
        return 's';

      case 'l':
        return 'm';

      default:
        return size;
    }
  };

  return useBreakpointValue({
    xs: smallerScreenCellSize(),
    xl: size
  });
};
//# sourceMappingURL=_useCellSize.js.map